import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import CoursesSection from './components/CoursesSection';
import AboutSection from './components/AboutSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <CoursesSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}
